import {logger} from 'yougile-util'
import {DataObjectId, ProjectIds} from 'yougile-model'
import {Backend} from '@common/backend'
import {globals} from '@extensions/globals-base'

export interface FetchIdProjectsResult {
  projectIds: ProjectIds
}

export const fetchIdProjects = async (
  projectIds: DataObjectId[]
): Promise<FetchIdProjectsResult | undefined> => {
  const companyId = globals.getCompanyId()

  if (!companyId || !projectIds || projectIds.length === 0) {
    return undefined
  }

  try {
    const resp = await Backend.postJSON<FetchIdProjectsResult>(
      '/data/id-tasks/get-project-ids',
      {
        ...Backend.loadCred(),
        companyId,
        projectIds
      }
    )

    return resp
  } catch (e) {
    logger.error('Cannot get id-task', e)
    return undefined
  }
}
